// src/pages/RequestDetails.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getOfferDetails } from '../../utils/api'; // or a similar API call
import './RequestDetails.css';

const RequestDetails = () => {
    const { id } = useParams(); // grabs /request/:id
    const [request, setRequest] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRequest = async () => {
            setLoading(true);
            try {
                const res = await getOfferDetails(id); // API call
                if (res.status === 200) {
                    setRequest(res.data || res.data.requests || null);
                } else {
                    setRequest(null);
                }
            } catch (err) {
                console.error(err);
                setRequest(null);
            } finally {
                setLoading(false);
            }
        };

        fetchRequest();
    }, [id]);

    if (loading) return <div className="loading">Loading...</div>;
    if (!request) return <div className="empty">Request not found</div>;

    return (
        <div className="request-details">
            <h2>Request Details - #{id}</h2>
            <div>
                <p><b>Product:</b> {request.product_name}</p>
                <p><b>Grade:</b> {request.grade_name}</p>
                <p><b>Brand:</b> {request.brand_name}</p>
                <p><b>Quantity:</b> {request.qty || request.seller_qty} MT</p>
                <p><b>Location:</b> {request.city_name}, {request.state_name}</p>
                <p><b>Created At:</b> {new Date(request.created_at).toLocaleString()}</p>
                {/* Add more fields as needed */}
            </div>
        </div>
    );
};

export default RequestDetails;
